import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetSuperbetTicketById, SetSuperbetId, RejectSuperbet } from "../../../actions/terminal";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";
import SuperbetOfferReview from "./offerReview";
import SuperbetOfferRejected from "./offerRejected";
import SuperbetOfferChange from "./offerChange";
import { BetslipCommunicator, BetslipEventsEnum } from "@betslip/communicator";
import { getAuthData } from "@common/helpers/auth";
import { asyncWrapper } from "@common/hocs/asyncWrapper";

import './style.scss';

const Superbet = ({
  closePopup,
  superBetId,
  isCounterOffer,
  superBetIsAlreadyAccepted,
}) => {
  const authData = getAuthData();

  // const swarmData = response.cashdesk?.[authData.tid]?.super_bet?.[superBetId];
  // const response = useSwarm(getBalanceSubscribtionRequest(tid), true);
  // const swarmData = response.terminals?.[authData.tid]?.super_bet?.[superBetId];

  const superbetData = useSelector(state => state.terminal.superbetData);

  const swarmData = superbetData?.[superBetId];

  const [acceptedStatus, setAcceptedStatus] = useState();
  const [superbetStatus, setSuperbetStatus] = useState();
  const [autoCloseTimerId, setAutoCloseTimerId] = useState();
  const [autoCloseTimer, setAutoCloseTimer] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => clearInterval(autoCloseTimerId);
  }, []);

  const acceptCounterOffer = async (status, superBetId) => {
    await swarmRequest({ Token: authData.token, Accept: true, BetId: superBetId }, "terminal_super_bet_answer").then(
      (data) => console.debug(data, "SUPER_BET_DATA")
    );
    setAcceptedStatus(status);
  };

  const rejectCounterOffer = (betId) => {
    swarmRequest({ Token: authData.token, Accept: false, BetId: betId }, "terminal_super_bet_answer").then((data) =>
      console.debug(data, "SUPER_BET_DATA")
    );
    closePopup();
  };

  const handlePrintTicket = (id) => {
    if (id) dispatch(GetSuperbetTicketById(id.toString()));
  };

  const handleRejectSuperbet = (id) => {
    dispatch(RejectSuperbet(id.toString()));
  };

  useEffect(() => {
    if (superBetId) {
      dispatch(SetSuperbetId(superBetId.toString()));
    }
  }, [superBetId]);

  const isOfferUnderReview = useMemo(() => {
    return !swarmData && superBetIsAlreadyAccepted === undefined;
  }, [swarmData]);

  const isOfferRejected = useMemo(() => {
    if (!swarmData) return superBetIsAlreadyAccepted === false;

    return !swarmData.is_counteroffer && swarmData.super_bet_status === -1;
  }, [swarmData]);

  const isOfferChanged = swarmData?.is_counteroffer;

  const { is_counteroffer, super_bet_status } = swarmData || {};

  const isOfferAccepted = useMemo(() => {
    if (!swarmData) return superBetIsAlreadyAccepted;

    return !is_counteroffer && (super_bet_status === 1 || acceptedStatus === 0);
  }, [swarmData, super_bet_status, is_counteroffer, superBetIsAlreadyAccepted, acceptedStatus]);

  useEffect(() => {
    if (isOfferAccepted) {
      BetslipCommunicator.send(BetslipEventsEnum.SuperbetAccepted);
      handlePrintTicket(superBetId);
      closePopup();
    }

    if (swarmData?.is_counteroffer && !autoCloseTimerId) {
      const timerId = setInterval(() => {
        const newTime = autoCloseTimer - 1;
        setAutoCloseTimer(newTime);
        if (newTime === 1) {
          rejectCounterOffer(swarmData.super_bet_id);
          clearInterval(autoCloseTimerId);
        }
      }, [1000]);

      setAutoCloseTimerId(timerId);
    }

    if (swarmData?.super_bet_status === 1 && !isOfferAccepted) {
      if (isCounterOffer) setSuperbetStatus(1);
      handlePrintTicket(superBetId);
      setTimeout(closePopup, 5000);
    }
    if (swarmData?.super_bet_status === -1) {
      handleRejectSuperbet(superBetId);
      setTimeout(closePopup, 5000);
    }
  }, [superbetStatus, superBetId, isOfferAccepted, autoCloseTimerId, swarmData, isCounterOffer]);

  if (isOfferUnderReview) {
    return <SuperbetOfferReview isCounterOffer={isCounterOffer} />;
  }

  if (isOfferRejected) {
    return <SuperbetOfferRejected isCounterOffer={isCounterOffer} declineReason={swarmData?.decline_reason?.trim()} />;
  }

  if (isOfferChanged) {
    return (
      <SuperbetOfferChange
        isCounterOffer={isCounterOffer}
        newOdd={swarmData.super_bet_price}
        newAmount={swarmData.super_bet_amount}
        acceptOffer={() => acceptCounterOffer(swarmData.super_bet_status, swarmData.super_bet_id)}
        rejectOffer={() => rejectCounterOffer(swarmData.super_bet_id)}
      />
    );
  }

  return null;
};

export default asyncWrapper(Superbet);
